export default __webpack_public_path__ + "static/media/3.ba1e4dd4.jpeg";